// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Api = require("../api");
var RelayEnv = require("../RelayEnv.bs.js");
var AuthSession = require("./AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var LoginListener = require("../reason/common/UserSession/LoginListener.bs.js");
var Nextjs = require("@sentry/nextjs");
var Core__Nullable = require("@rescript/core/src/Core__Nullable.bs.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var AuthSessionRelayQuery_graphql = require("../__generated__/AuthSessionRelayQuery_graphql.bs.js");
var AuthSessionRelay_query_graphql = require("../__generated__/AuthSessionRelay_query_graphql.bs.js");

var convertVariables = AuthSessionRelayQuery_graphql.Internal.convertVariables;

var convertResponse = AuthSessionRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = AuthSessionRelayQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, AuthSessionRelayQuery_graphql.node, convertResponse);

RescriptRelay_Query.useLoader(convertVariables, AuthSessionRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.usePreloaded(AuthSessionRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(AuthSessionRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(AuthSessionRelayQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(AuthSessionRelayQuery_graphql.node, convertVariables);

var commitLocalPayload = RescriptRelay_Query.commitLocalPayload(AuthSessionRelayQuery_graphql.node, convertVariables, convertWrapRawResponse);

var convertFragment = AuthSessionRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AuthSessionRelay_query_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AuthSessionRelay_query_graphql.node, convertFragment, fRef);
}

function updateCurrentAuthSession_(data) {
  commitLocalPayload(RelayEnv.environment, undefined, {
        currentAuthSession: data
      });
}

function useCurrentAuthSession_() {
  var data = use(undefined, "store-only", undefined, undefined);
  return use$1(data.fragmentRefs).currentAuthSession;
}

AuthSession.Internal.useCurrentAuthSession_.contents = useCurrentAuthSession_;

async function oneShotReadDataFromStore() {
  var data = await fetchPromised(RelayEnv.environment, undefined, undefined, undefined);
  return (await waitForFragmentData(RelayEnv.environment, data.fragmentRefs)).currentAuthSession;
}

var inFlightCreateSessionPromise = {
  contents: undefined
};

var inFlightLogoutPromise = {
  contents: undefined
};

async function createSession() {
  var p = inFlightCreateSessionPromise.contents;
  if (p !== undefined) {
    return await Caml_option.valFromOption(p);
  }
  var p$1 = Api.createSession();
  inFlightCreateSessionPromise.contents = Caml_option.some(p$1);
  var results;
  try {
    results = await p$1;
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    console.error(e);
    inFlightCreateSessionPromise.contents = undefined;
    throw e;
  }
  Nextjs.setUser({
        id: results.user.id,
        email: results.user.email
      });
  inFlightCreateSessionPromise.contents = undefined;
  return results;
}

async function logout() {
  var p = inFlightLogoutPromise.contents;
  if (p !== undefined) {
    return await Caml_option.valFromOption(p);
  }
  var p$1 = Api.logout();
  inFlightLogoutPromise.contents = Caml_option.some(p$1);
  var r;
  try {
    r = await p$1;
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    console.error(e);
    inFlightLogoutPromise.contents = undefined;
    throw e;
  }
  Nextjs.setUser({});
  inFlightLogoutPromise.contents = undefined;
  return r;
}

async function createSession$1() {
  var session;
  try {
    session = await createSession();
  }
  catch (exn){
    return updateCurrentAuthSession_({
                __typename: "AuthSessionUnauthenticated",
                __typename: "AuthSessionUnauthenticated",
                dummy: true
              });
  }
  var expiresAt = Date.now() + session.expiresIn * 1000;
  var match = session.user.role;
  return updateCurrentAuthSession_({
              __typename: "AuthSession",
              __typename: "AuthSession",
              expiresAt: expiresAt,
              isImpersonated: Core__Nullable.getOr(session.impersonated, false),
              token: session.accessToken,
              user: {
                id: session.user.id,
                role: match === "agent" ? "AGENT" : "CLIENT"
              }
            });
}

AuthSession.Internal.createSession_.contents = createSession$1;

async function readToken() {
  var match = await oneShotReadDataFromStore();
  if (match !== undefined && match.__typename === "AuthSession") {
    return match.token;
  }
  
}

async function getWithExpiryCheck_(operationName) {
  var match = await oneShotReadDataFromStore();
  if (match !== undefined) {
    switch (match.__typename) {
      case "AuthSession" :
          if (Date.now() > match.expiresAt) {
            await createSession$1();
            return await readToken();
          } else {
            return match.token;
          }
      case "AuthSessionInitializing" :
          await createSession$1();
          return await readToken();
      case "AuthSessionUnauthenticated" :
      case "__unselected" :
          return ;
      
    }
  } else {
    updateCurrentAuthSession_({
          __typename: "AuthSessionInitializing",
          __typename: "AuthSessionInitializing",
          dummy: true
        });
    await createSession$1();
    return await readToken();
  }
}

AuthSession.Internal.getWithExpiryCheck_.contents = getWithExpiryCheck_;

async function logout_() {
  var val;
  try {
    val = await logout();
  }
  catch (exn){
    return ;
  }
  ((window.location.href = "/login"));
}

AuthSession.Internal.logout_.contents = logout_;

function loginSuccess(session) {
  var expiresAt = Date.now() + session.expiresIn * 1000;
  Nextjs.setUser({
        id: session.user.id,
        email: session.user.email
      });
  LoginListener.didLogin();
  var match = session.user.role;
  updateCurrentAuthSession_({
        __typename: "AuthSession",
        __typename: "AuthSession",
        expiresAt: expiresAt,
        isImpersonated: session.impersonated,
        token: session.accessToken,
        user: {
          id: session.user.id,
          role: match === "agent" ? "AGENT" : "CLIENT"
        }
      });
}

AuthSession.Internal.loginSuccess_.contents = loginSuccess;

var dummy = "";

exports.dummy = dummy;
/* use Not a pure module */
